
// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const Projects = () => {

//   const navigate = useNavigate();

//   const handleProjectClick = () => {
//     navigate('/project-details', { state: {} });
//   };

//   const projectList = [
//     {
//       title: 'Rcc',
//       description: 'Complete structural analysis, design, and detailing of a 50,000 sq. ft. industrial steel building using AISC standards.',
//       image: require('../Images/slide4.jpg'),

//     },
//     {
//       title: 'Steel',
//       description: 'Light gauge steel structure for a high-end villa project, optimized for quick assembly and seismic zones.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Cold-formed steel',
//       description: 'Custom-designed aluminum canopy structure with wind-load and dead-load calculations.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Aluminium',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Precast',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Lumber Structure',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Machine house',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Log-House(Lumber)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Warehouse Design',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Clean room',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Sculpture',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Playground equipment',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Glass structure',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Platform',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Solar Panel',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'CFS (module structure)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Earthbag',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Lit House (CFS)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'BEMB',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Sign Board',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Letter Design',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Animal Sculpture',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Earthbag home',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Theme park',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Glass Dome',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: ' Stairs  (lumber,spiral)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Mars factory',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },

//   ];

//   const projectStats = [
//     { title: 'Warehouse Design', count: 25 },
//     { title: 'Staircase & Railing Designs', count: 350 },
//     { title: 'Theme Park Specialty Structures', count: 1 },
//     { title: 'Sign Board Design', count: 8 },
//     { title: 'Kit Home Design', count: 18 },
//     { title: 'Anchors & Baseplate Design', count: 58 },
//     { title: 'Lumber Houses', count: 28 },
//     { title: 'Solar Support Structure', count: 4 },
//     { title: 'Curb Design', count: 14 },
//     { title: 'Cold Form Steel Homes', count: 35 },
//   ];

//   return (
//     <div style={styles.container}>

//       <h2 style={styles.heading}>
//         Our <span style={{ color: '#f37021' }}>Projects</span>
//       </h2>

//       <p style={styles.subHeading}>
//         At StructGuard Engineers LLP, we pride ourselves on delivering innovative, efficient, and accurate structural engineering solutions. Here’s a glimpse of some of our recent works:
//       </p>
//       <div style={styles.grid}>
//         {projectList.map((project, index) => (
//           <div key={index} style={styles.card} onClick={() => navigate('/projectdetails', {
//             state:
//             {
//               project: {
//                 title: project.title,
//                 description: project.description,
//               },
//             }
//           })} >
//             <img src={project.image} alt={project.title} style={styles.image} />
//             <h3 style={styles.cardTitle}>{project.title}</h3>
//             <p style={styles.cardText}>{project.description}</p>
//           </div>
//         ))}
//       </div>

//       {/* <div style={styles.statsContainer}>
//         {projectStats.map((item, index) => (
//           <div key={index} style={styles.statItem}>
//             <h3 style={styles.statCount}>{item.count}</h3>
//             <p style={styles.statTitle}>{item.title}</p>
//           </div>
//         ))}
//       </div> */}
//     </div>


//   );
// };

// const styles = {
//   container: {
//     padding: '3% 5%',
//     backgroundColor: '#fff',
//     // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//     minHeight: '100vh',
//   },
//   heading: {
//     textAlign: 'center',
//     fontSize: '2.5rem',
//     marginBottom: '10px',
//     color: '#0A1733',
//   },
//   subHeading: {
//     textAlign: 'center',
//     fontSize: '1rem',
//     marginBottom: '40px',
//     color: 'grey',
//     maxWidth: '800px',
//     margin: '0 auto 40px auto',
//   },
//   grid: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     justifyContent: 'space-around',
//     gap: '30px',

//   },
//   card: {
//     width: '300px',
//     textAlign: 'left',
//     // background: 'rgba(255, 255, 255, 0.1)',
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//     overflow: 'hidden',
//     filter: 'drop-shadow(2px 2px 3px #000)',
//     transform: 'translateZ(20px)',



//     // background: 'rgba(255, 255, 255, 0.1)',
//     // border: '1px solid rgba(255, 255, 255, 0.2)',
//     // borderRadius: '15px',
//     // padding: '1.5rem',
//     // width: '280px',
//     // textAlign: 'center',
//     // boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
//     // backdropFilter: 'blur(10px)',
//     // color: '#fff',
//     // marginBottom: '40px',
//   },
//   image: {
//     width: '100%',
//     height: '180px',
//     objectFit: 'cover',
//   },
//   cardTitle: {
//     padding: '10px 15px',
//     fontSize: '1.2rem',
//     fontWeight: 'bold',
//     color: '#0A1733',
//   },
//   cardText: {
//     padding: '0 15px 15px 15px',
//     color: 'grey',
//     fontSize: '0.95rem',
//   },
//   statsContainer: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     justifyContent: 'space-around',
//     padding: '20px 0',
//     borderRadius: '10px',
//     boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
//     marginBottom: '40px',
//     margin: '10px',

//     background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//     borderRadius: '12px',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//     overflow: 'hidden',
//     filter: 'drop-shadow(2px 2px 3px #000)',
//     transform: 'translateZ(20px)',
//   },
//   statItem: {
//     width: '180px',
//     textAlign: 'center',
//     padding: '15px',
//   },
//   statCount: {
//     fontSize: '2rem',
//     color: '#f37021',
//     marginBottom: '5px',
//   },
//   statTitle: {
//     fontSize: '0.95rem',
//     color: 'white',
//   },
// };

// export default Projects;


// import React, { useEffect, useRef, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';


// const Projects = () => {

//   useEffect(() => {
//     scrollToCenter(centerIndex);
//   }, []);

//   const navigate = useNavigate();
//   const scrollRef = useRef(null);
//   const [centerIndex, setCenterIndex] = useState(1); // Start from 1 to show the second item highlighted
//   const [hoverIndex, setHoverIndex] = useState(null);

//   const scrollToCenter = (index) => {
//     const container = scrollRef.current;
//     const card = container.children[index];
//     const containerWidth = container.offsetWidth;
//     const cardWidth = card.offsetWidth;
//     const scrollPosition = card.offsetLeft - (containerWidth / 2 - cardWidth / 2);

//     container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
//     setCenterIndex(index);
//   };

//   const scrollLeft = () => {
//     if (centerIndex > 0) {
//       scrollToCenter(centerIndex - 1);
//     }
//   };

//   const scrollRight = () => {
//     if (centerIndex < projectList.length - 1) {
//       scrollToCenter(centerIndex + 1);
//     }
//   };


//   const handleProjectClick = (project) => {
//     navigate('/projectdetails', { state: { project } });
//   };

//   const projectList = [
//     {
//       title: 'Rcc',
//       description: 'Complete structural analysis, design, and detailing of a 50,000 sq. ft. industrial steel building using AISC standards.',
//       image: require('../Images/slide4.jpg'),

//     },
//     {
//       title: 'Steel',
//       description: 'Light gauge steel structure for a high-end villa project, optimized for quick assembly and seismic zones.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Cold-formed steel',
//       description: 'Custom-designed aluminum canopy structure with wind-load and dead-load calculations.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Aluminium',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Precast',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Lumber Structure',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Machine house',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Log-House(Lumber)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Warehouse Design',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Clean room',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Sculpture',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Playground equipment',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Glass structure',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Platform',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Solar Panel',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'CFS (module structure)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Earthbag',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Lit House (CFS)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'BEMB',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Sign Board',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Letter Design',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Animal Sculpture',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Earthbag home',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Theme park',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Glass Dome',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: ' Stairs  (lumber,spiral)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Mars factory',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },

//   ];

//   return (
//     <div style={styles.container}>

//       <h2 style={styles.heading}>
//         Built By <span style={{ color: '#f37021', }}>StructGuard</span> 
//       </h2>
//         <p style={{ color: '#0A1733',fontSize: '1.5rem', }} >At StructGuard Engineers LLP, we take pride in delivering innovative and reliable structural engineering solutions across diverse industries and geographies. From concept to completion, our projects reflect a balance of safety, functionality, and aesthetics, backed by global expertise and advanced engineering tools.</p>

//       <div style={styles.carouselWrapper}>

//         <button onClick={scrollLeft} style={{ ...styles.arrow, color: '#f37021' }}>
//           <FaChevronLeft size={40} />
//         </button>

//         <div style={styles.carousel} ref={scrollRef}>
//           {projectList.map((project, index) => {
//             const isCenter = index === centerIndex;
//             const isSide = Math.abs(index - centerIndex) === 1;

//             return (
//               <div
//                 key={index}
//                 style={{
//                   ...styles.card,
//                   opacity: index === centerIndex ? 1 : 0.5,
//                   transform: index === centerIndex ? 'scale(1.05)' : 'scale(0.95)',
//                   // transform: index === centerIndex ? 'scale(1.15)' : 'scale(0.9)',
//                   zIndex: index === centerIndex ? 10 : 1,
//                   transition: 'all 0.3s ease',
//                   border: index === centerIndex ? '2px solid #f37021' : 'none',
//                   padding: index === centerIndex ? '9px' : '0', // spacing between border and content
//                   boxSizing: 'border-box',
//                 }}
//                 onClick={() => handleProjectClick(project)}
//                 onMouseEnter={() => setHoverIndex(index)}
//                 onMouseLeave={() => setHoverIndex(null)}
//               >
//                 <div style={styles.innerCard}>
//                   <img src={project.image} alt={project.title} style={styles.image} />
//                   <div style={styles.cardContent}>
//                     <h3 style={styles.cardTitle}>{project.title}</h3>
//                     <p style={styles.cardText}>{project.description}</p>
//                   </div>
//                   <div
//                     style={{
//                       ...styles.overlay,
//                       ...(hoverIndex === index ? styles.overlayVisible : {}),
//                     }}
//                   >
//                     Open for more details
//                   </div>
//                 </div>
//               </div>



//             );


//           })}


//         </div>

//         <button onClick={scrollRight} style={{ ...styles.arrow, color: '#f37021' }}>
//           <FaChevronRight size={40} />
//         </button>

//       </div>

//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: '3% 5%',
//     backgroundColor: '#f9fafc',
//     minHeight: '100vh',

//   },
//   heading: {
//     textAlign: 'center',
//     // fontSize: '2.5rem',
//     // marginBottom: '40px',
//     color: '#0A1733',
//     fontSize: '60px'
//   },
//   carouselWrapper: {
//     display: 'flex',
//     alignItems: 'center',          // vertical alignment
//     justifyContent: 'center',      // horizontal alignment
//     position: 'relative',
//     height: '100vh',               // full viewport height
//     width: '100%',

//   },

//   arrow: {
//     fontSize: '2rem',
//     backgroundColor: 'transparent',
//     border: 'none',
//     cursor: 'pointer',
//     padding: '10px',
//     color: '#f37021', // ← Add this
//   },
//   // carousel: {
//   //   display: 'flex',
//   //   overflow: 'hidden',
//   //   scrollBehavior: 'smooth',
//   //   gap: '20px',
//   //   width: '100%',
//   //   scrollSnapType: 'x mandatory',
//   //   padding: '20px 0',
//   // },
//   carousel: {
//     display: 'flex',
//     overflowX: 'auto',
//     scrollSnapType: 'x mandatory',
//     scrollPadding: '0 50%', // gives padding for centering
//     gap: '30px',
//     padding: '20px 0',
//     scrollbarWidth: 'none', // hide scrollbar in Firefox
//   },
//   innerCard: {
//     borderRadius: '12px',
//     overflow: 'hidden',
//     background: '#fff',
//     height: '100%',
//     boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//     position: 'relative',
//   },
//   card: {
//     flex: '0 0 300px',
//     scrollSnapAlign: 'center',
//     borderRadius: '15px',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//   },

//   // card: {
//   //   flex: '0 0 300px',
//   //   background: '#fff',
//   //   borderRadius: '12px',
//   //   boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//   //   overflow: 'hidden',
//   //   cursor: 'pointer',
//   //   scrollSnapAlign: 'center',
//   //   transition: 'transform 0.3s ease, opacity 0.3s ease',
//   //   position: 'relative',
//   // },
//   cardContent: {
//     padding: '10px 15px 15px 15px',
//   },
//   overlay: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     height: '100%',
//     width: '100%',
//     background: 'rgba(0,0,0,0.6)',
//     color: 'white',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     opacity: 0,
//     fontSize: '1rem',
//     fontWeight: 'bold',
//     transition: 'opacity 0.3s ease',
//     pointerEvents: 'none',
//     textAlign: 'center',
//     padding: '10px',
//   },
//   overlayVisible: {
//     opacity: 1,
//     pointerEvents: 'auto',
//   },
//   image: {
//     width: '100%',
//     height: '180px',
//     objectFit: 'cover',
//   },
//   cardTitle: {
//     padding: '10px 15px',
//     fontSize: '1.2rem',
//     fontWeight: 'bold',
//     color: '#0A1733',
//   },
//   cardText: {
//     padding: '0 15px 15px 15px',
//     color: 'grey',
//     fontSize: '0.95rem',
//   },
// };

// export default Projects;


// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { motion } from "framer-motion"; // ← animation library

// const Projects = () => {
//   const navigate = useNavigate();
//   const scrollRef = useRef(null);
//   const [centerIndex, setCenterIndex] = useState(1);
//   const [hoverIndex, setHoverIndex] = useState(null);

//   useEffect(() => {
//     scrollToCenter(centerIndex);
//   }, []);

//   const scrollToCenter = (index) => {
//     const container = scrollRef.current;
//     const card = container.children[index];
//     const containerWidth = container.offsetWidth;
//     const cardWidth = card.offsetWidth;
//     const scrollPosition =
//       card.offsetLeft - (containerWidth / 2 - cardWidth / 2);

//     container.scrollTo({ left: scrollPosition, behavior: "smooth" });
//     setCenterIndex(index);
//   };

//   const scrollLeft = () => {
//     if (centerIndex > 0) {
//       scrollToCenter(centerIndex - 1);
//     }
//   };

//   const scrollRight = () => {
//     if (centerIndex < projectList.length - 1) {
//       scrollToCenter(centerIndex + 1);
//     }
//   };

//   const handleProjectClick = (project) => {
//     navigate("/projectdetails", { state: { project } });
//   };

//   const projectList = [
//     {
//       title: 'Rcc',
//       description: 'Complete structural analysis, design, and detailing of a 50,000 sq. ft. industrial steel building using AISC standards.',
//       image: require('../Images/slide4.jpg'),

//     },
//     {
//       title: 'Steel',
//       description: 'Light gauge steel structure for a high-end villa project, optimized for quick assembly and seismic zones.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Cold-formed steel',
//       description: 'Custom-designed aluminum canopy structure with wind-load and dead-load calculations.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Aluminium',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Precast',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Lumber Structure',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Machine house',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Log-House(Lumber)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Warehouse Design',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Clean room',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Sculpture',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Playground equipment',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Glass structure',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Platform',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Solar Panel',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'CFS (module structure)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Earthbag',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Lit House (CFS)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'BEMB',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Sign Board',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Letter Design',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Animal Sculpture',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Earthbag home',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Theme park',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Glass Dome',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: ' Stairs  (lumber,spiral)',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },
//     {
//       title: 'Mars factory',
//       description: 'Precast RCC structure layout, detailing, and connection design for a multi-floor hospital.',
//       image: require('../Images/slide4.jpg'),
//     },

//   ];

//   return (
//     <div style={styles.container}>
//       <motion.h2
//         style={styles.heading}
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//       >
//         Built By <span style={{ color: "#f37021" }}>StructGuard</span>
//       </motion.h2>

//       <motion.p
//         style={{ color: "#0A1733", fontSize: "1.5rem", textAlign: "center" }}
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.3, duration: 0.6 }}
//       >
//         At StructGuard Engineers LLP, we take pride in delivering innovative
//         and reliable structural engineering solutions...
//       </motion.p>

//       <div style={styles.carouselWrapper}>
//         <button onClick={scrollLeft} style={{ ...styles.arrow, color: "#f37021" }}>
//           <FaChevronLeft size={40} />
//         </button>

//         <div style={styles.carousel} ref={scrollRef}>
//           {projectList.map((project, index) => {
//             const isCenter = index === centerIndex;

//             return (
//               <motion.div
//                 key={index}
//                 style={{
//                   ...styles.card,
//                   opacity: isCenter ? 1 : 0.5,
//                   transform: isCenter ? "scale(1.1)" : "scale(0.9)",
//                   zIndex: isCenter ? 10 : 1,
//                   border: isCenter ? "2px solid #f37021" : "none",
//                 }}
//                 onClick={() => handleProjectClick(project)}
//                 onMouseEnter={() => setHoverIndex(index)}
//                 onMouseLeave={() => setHoverIndex(null)}
//                 whileHover={{ scale: 1.15 }}
//                 transition={{ type: "spring", stiffness: 200 }}
//               >
//                 <motion.div
//                   style={styles.innerCard}
//                   whileHover={{ y: -10 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <img src={project.image} alt={project.title} style={styles.image} />
//                   <div style={styles.cardContent}>
//                     <h3 style={styles.cardTitle}>{project.title}</h3>
//                     <p style={styles.cardText}>{project.description}</p>
//                   </div>
//                   <motion.div
//                     style={{
//                       ...styles.overlay,
//                       ...(hoverIndex === index ? styles.overlayVisible : {}),
//                     }}
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: hoverIndex === index ? 1 : 0 }}
//                     transition={{ duration: 0.3 }}
//                   >
//                     🚀 Open for more details
//                   </motion.div>
//                 </motion.div>
//               </motion.div>
//             );
//           })}
//         </div>

//         <button onClick={scrollRight} style={{ ...styles.arrow, color: "#f37021" }}>
//           <FaChevronRight size={40} />
//         </button>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: "3% 5%",
//     background: "linear-gradient(135deg, #f9fafc, #eef2f6)",
//     minHeight: "100vh",
//   },
//   heading: {
//     textAlign: "center",
//     color: "#0A1733",
//     fontSize: "60px",
//     fontWeight: "bold",
//   },
//   carouselWrapper: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "relative",
//     height: "100vh",
//     width: "100%",
//   },
//   arrow: {
//     fontSize: "2rem",
//     backgroundColor: "white",
//     borderRadius: "50%",
//     boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
//     border: "none",
//     cursor: "pointer",
//     padding: "10px",
//     transition: "0.3s",
//   },
//   carousel: {
//     display: "flex",
//     overflowX: "auto",
//     scrollSnapType: "x mandatory",
//     gap: "30px",
//     padding: "20px 0",
//     scrollbarWidth: "none",
//   },
//   innerCard: {
//     borderRadius: "15px",
//     overflow: "hidden",
//     background: "#fff",
//     height: "100%",
//     boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
//     position: "relative",
//   },
//   card: {
//     flex: "0 0 320px",
//     scrollSnapAlign: "center",
//     borderRadius: "15px",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },
//   cardContent: {
//     padding: "10px 15px 15px 15px",
//   },
//   overlay: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     height: "100%",
//     width: "100%",
//     background: "rgba(0,0,0,0.6)",
//     color: "white",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     opacity: 0,
//     fontSize: "1rem",
//     fontWeight: "bold",
//     transition: "opacity 0.3s ease",
//     pointerEvents: "none",
//     textAlign: "center",
//     padding: "10px",
//   },
//   overlayVisible: {
//     opacity: 1,
//     pointerEvents: "auto",
//   },
//   image: {
//     width: "100%",
//     height: "200px",
//     objectFit: "cover",
//   },
//   cardTitle: {
//     padding: "10px 15px",
//     fontSize: "1.4rem",
//     fontWeight: "bold",
//     color: "#0A1733",
//   },
//   cardText: {
//     padding: "0 15px 15px 15px",
//     color: "grey",
//     fontSize: "0.95rem",
//   },
// };

// export default Projects;

import React, { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion, useMotionValue, useTransform } from "framer-motion";

import aluminumimg from '../Images//projectimages/Aluminum Frame.png'
import tank from '../Images/projectimages/Tanks 01.png'
import shopdrw from '../Images/projectimages/Shop Drawings.png'

import rccimg from '../Images/Temproj/rcc.webp'
import steelimg from '../Images/Temproj/Steelimg.jpg'
import cfsimg from '../Images/projectimages/CFS1.jpg'
import precastimg from '../Images/Temproj/precastimg.jpg'
import lumhouimg from '../Images/projectimages/loghouse1.png'
import lumstr from '../Images/Temproj/residential Lumber Structure at Hawaii.png'
import wareimg from '../Images/projectimages/WareHouse Buildings 02.png'
import glassstruimg from '../Images/Temproj/Glass House-1.png'
import machinehouseimg from '../Images/Temproj/machine house.png'
import butterflyimg from '../Images/Temproj/butterfly.png'
import stairflyimg from '../Images/Temproj/stair.png'
import domeimg from '../Images/Temproj/Dome house..png'
import specialstru from '../Images/projectimages/Mobility Platforms & Ramps.png'
import customrenov from '../Images/projectimages/Strengthening of Existing Structure 01.png'
import signbimg from '../Images/Temproj/signboardimg.jpg'
import cleanrimg from '../Images/Temproj/cleanroomimg.jpg'
import plge from '../Images/Temproj/Playgroundequipmentimg.jpg'
import platform from '../Images/projectimages/platform3.png'
import industrialequ from '../Images/projectimages/Industrial Equipment Platform, foundation and anchor design 01.png'
import pemb from '../Images/projectimages/Warehouse-steel structure.png'
import retaningwall from '../Images/projectimages/Segmental Retaining walls.png'
import poolhouse from '../Images/projectimages/Pool House with Retractable canopy in NY 02.png'
import earthbagimg from '../Images/projectimages/Earthbag Homes 01.png'
import letterdesign from '../Images/projectimages/signboard1.png'
import domehouse from '../Images/projectimages/Dome house..png'
import connection from '../Images/projectimages/conn3.png';
import unistrut from '../Images/projectimages/unistrut1.png';
import Cablebracing from '../Images/projectimages/cablebracing2.png';
import canopyimg from '../Images/projectimages/canopy1.png';
import tower2 from '../Images/projectimages/tower1.png';
import trussdesign from '../Images/projectimages/trussdesign1.png';
import rackdesign from '../Images/projectimages/rack1.png';













import { AppConstant } from "../AppConstant";
import Header from "../Components/Header";
import Footer from "../Components/Footer";




const Projects = () => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [centerIndex, setCenterIndex] = useState(1);
  const [hoverIndex, setHoverIndex] = useState(null);
  const autoplayRef = useRef(null);




  const projectList = useMemo(
    () => [
      {
        title: "Tanks",
        description: "Design and analysis of reinforced concrete and steel water tanks ensuring strength, durability, and leak-proof performance.",
        image: tank,
      },
      {
        title: "Shop Drawings",
        description: "Detailed fabrication drawings for structural elements, ensuring precision and compliance with design standards.",
        image: shopdrw,
      },
      {
        title: "RCC",
        description: "We are specialized in Reinforced Cement Concrete Structures which includes Foundations for Steel & wooden building, Multi-storey Towers and Residential bungalows.",
        image: rccimg,
      },
      {
        title: "Hot Rolled Steel",
        description: "Structural steel design including frames, trusses, and connections for industrial and commercial projects.",
        image: steelimg,
      },
      {
        title: "Cold-Formed Steel",
        description: "We provide complete structural engineering and detailing (Structural package and shop drawings) services ",
        image: cfsimg,
      },
      {
        title: "Aluminium",
        description: "Custom aluminium structures offering strength, corrosion resistance, and aesthetic appeal.",
        image: aluminumimg,
      },
      {
        title: "Precast",
        description: "We provide complete structural engineering and detailing (Structural package and shop drawings) services ",
        image: precastimg,
      },
      {
        title: "Lumber Structure",
        description: "Structural Design of Residential, commercial wooden framing structures",
        image: lumstr,
      },
      {
        title: "Machine House",
        description: "Structural design of machine housing for vibration control, durability, lifting and safety compliance.",
        image: machinehouseimg,
      },
      {
        title: "Log-House",
        description: "Structural log-house designs combining traditional aesthetics with modern engineering safety.",
        image: lumhouimg,
      },
      {
        title: "Warehouse Design",
        description: "Structural systems for warehouses focusing on space optimization, load capacity, and cost-efficiency.",
        image: wareimg,
      },
      {
        title: "Clean Room",
        description: "Specialized structural design for clean rooms maintaining safety, airtightness, and load requirements.",
        image: cleanrimg,
      },
      {
        title: "Sculpture",
        description: "Engineering support for large-scale sculptures ensuring stability, balance, and safety in public spaces.",
        image: butterflyimg,
      },
      {
        title: "Playground Equipment",
        description: "Safe and durable structural design of playground frames, swings, and climbing systems.",
        image: plge,
      },
      {
        title: "Special Structure",
        description: "Custom-engineered solutions for unique and complex structural requirements.",
        image: specialstru,
      },
      {
        title: "Platform",
        description: "Design of structural platforms for heavy loads, accessibility, and safety compliance.",
        image: platform,
      },
      {
        title: "Solar Panel",
        description: "Structural mounting solutions for solar panels.",
        image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?q=80&w=1600&auto=format&fit=crop",
      },
      {
        title: "Custom Renovation",
        description: "Structural modifications and reinforcement solutions for renovation and retrofitting projects.",
        image: customrenov,
      },
      {
        title: "Industrial Equipment",
        description: "Foundation and support structures for heavy industrial machinery and equipment.",
        image: industrialequ,
      },
      {
        title: "Retaining Walls",
        description: "retaining wall design to ensure slope stability and durability.",
        image: retaningwall,
      },
      {
        title: "Kit Homes",
        description: "Pre-engineered kit Homes structures offering fast assembly with strength and stability.",
        image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?q=80&w=1600&auto=format&fit=crop",
      },
      {
        title: "PEMB",
        description: "Pre-engineered building design solutions for warehouses, factories, and industrial spaces.",
        image: pemb,
      },
      {
        title: "Sign Board",
        description: "Structural frames and foundations for large signage ensuring wind resistance and safety.",
        image: signbimg,
      },
      {
        title: "Letter Design",
        description: "Engineering for Metal letter structures with stable foundations & Anchors.",
        image: letterdesign,
      },
      // {
      //   title: "Pool House",
      //   description: "Design of poolside structures with durable framing, roofing, and corrosion protection.",
      //   image: poolhouse,
      // },
      {
        title: "Earthbag Home",
        description: "Sustainable structural solutions for earthbag homes with stability and eco-efficiency.",
        image: earthbagimg,
      },
      {
        title: "Glass Structures",
        description: "Engineering of glass facades and structural glazing ensuring safety and aesthetics.",
        image: glassstruimg,
      },
      {
        title: "Stairs, Railing & Ladder (Lumber, Steel, Aluminium)",
        description: "Structural stair design in lumber, steel & Aluminium ",
        image: stairflyimg,
      },
      {
        title: "Dome House",
        description: "Innovative dome-shaped structures engineered for strength, energy efficiency, and sustainable living.",
        image: domehouse,
      },
      {
        title: "Connection",
        description: "We provide advanced structural connection solutions that ensure strength, durability, and ease of installation. Our designs prioritize safety and reliability for a wide range of applications.",
        image: connection,
      },
      {
        title: "Unistrut System",
        description: "A versatile framing system designed for support and mounting. The Unistrut system allows quick, adjustable, and secure installations without the need for welding, making it ideal for industrial and commercial projects.",
        image: unistrut,
      },
      {
        title: "Temporary Cable Bracing",
        description: "Engineered cable bracing systems that provide temporary stability during construction. These braces are quick to install, adjustable, and ensure structural safety until permanent systems are in place.",
        image: Cablebracing,
      },
      {
        title: "Canopy Design",
        description: "Innovative and durable canopy solutions that combine functionality with aesthetics. Designed to provide shade, weather protection, and architectural appeal for a variety of applications.",
        image: canopyimg,
      },
      {
        title: "Tower Structures",
        description: "Custom-designed steel and composite towers for telecom, power transmission, and industrial use. Engineered for strength, durability, and optimized load-bearing capacity.",
        image: tower2,
      },
      {
        title: "Truss Design",
        description: "Efficient and economical truss systems tailored to meet project-specific loads and spans. Ensuring lightweight yet strong support for roofing System.",
        image: trussdesign,
      },
      {
        title: "Rack Design",
        description: "High-performance rack systems engineered for maximum space utilization and load efficiency. Suitable for warehouses, data centers, and industrial storage solutions.",
        image: rackdesign,
      },

    ],
    []
  );



  useEffect(() => {
    if (!scrollRef.current) return;
    scrollToCenter(centerIndex, false);
    // observe scroll to recompute center item
    const el = scrollRef.current;
    const onScroll = () => {
      const idx = findNearestIndex();
      setCenterIndex(idx);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // optional autoplay (comment out to disable)
  useEffect(() => {
    autoplayRef.current = setInterval(() => {
      scrollRight();
    }, 3500);
    return () => clearInterval(autoplayRef.current);
  }, [centerIndex, projectList.length]);

  const scrollToCenter = (index, smooth = true) => {
    const container = scrollRef.current;
    if (!container) return;
    const card = container.children[index];
    if (!card) return;
    const containerWidth = container.offsetWidth;
    const cardWidth = card.offsetWidth;
    const scrollPosition =
      card.offsetLeft - (containerWidth / 2 - cardWidth / 2);
    container.scrollTo({ left: scrollPosition, behavior: smooth ? "smooth" : "auto" });
  };




  const findNearestIndex = () => {
    const container = scrollRef.current;
    if (!container) return centerIndex;
    const mid = container.scrollLeft + container.offsetWidth / 2;
    let nearest = 0;
    let minDist = Infinity;
    for (let i = 0; i < container.children.length; i++) {
      const child = container.children[i];
      const childMid = child.offsetLeft + child.offsetWidth / 2;
      const d = Math.abs(childMid - mid);
      if (d < minDist) {
        minDist = d;
        nearest = i;
      }
    }
    return nearest;
  };

  const scrollLeft = () => {
    if (centerIndex <= 0) return;
    scrollToCenter(centerIndex - 1);
  };

  const scrollRight = () => {
    if (centerIndex >= projectList.length - 1) {
      // wrap to start for continuous feel
      scrollToCenter(0);
    } else {
      scrollToCenter(centerIndex + 1);
    }
  };


  const handleProjectClick = (project) => {
    navigate("/projectdetails", { state: { project } });
  };

  // keyboard arrows
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowLeft") scrollLeft();
      if (e.key === "ArrowRight") scrollRight();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  return (
    <>
      <Header />
      <div style={styles.container}>
        {/* heading */}
        <motion.h2
          style={styles.heading}
          initial={{ opacity: 0, y: -24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Built By <span style={{ color: "#f37021" }}>StructGuard</span>
        </motion.h2>

        <motion.p
          style={styles.subheading}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
        >
        Our Works Blend Safety, Aesthetics & Performance — Engineered with Precision and Delivered with Pride.
        </motion.p>

        <div style={{}}>
          {/* arrows */}
          {/* <button onClick={scrollLeft} style={styles.arrowLeft} aria-label="Previous">
            <FaChevronLeft size={28} />
          </button>
          <button onClick={scrollRight} style={styles.arrowRight} aria-label="Next">
            <FaChevronRight size={28} />
          </button> */}

          {/* carousel */}
          {/* <div style={styles.carouselWrap}>
            <div style={styles.carousel} ref={scrollRef}>
              {projectList.map((project, index) => {
                const active = index === centerIndex;
                return (
                  <CircleCard
                    key={project.title + index}
                    active={active}
                    project={project}
                    onClick={() => handleProjectClick(project)}
                    onHover={(v) => setHoverIndex(v ? index : null)}
                  />
                );
              })}
            </div>
          </div> */}

          {/* dots */}
          {/* <div style={styles.dots}>
            {projectList.map((_, i) => (
              <button
                key={i}
                onClick={() => scrollToCenter(i)}
                style={{
                  ...styles.dot,
                  width: i === centerIndex ? 28 : 8,
                  opacity: i === centerIndex ? 1 : 0.5,
                }}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div> */}

          <div style={{ padding: "40px 5%", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "32px" }}>
            {projectList.map((project, index) => {
              const active = index === centerIndex; // you can keep this or drop if not needed
              return (
                <CircleCard
                  key={project.title + index}
                  active={active}
                  project={project}
                  onClick={() => handleProjectClick(project)}
                  onHover={(v) => setHoverIndex(v ? index : null)}
                />
              );
            })}
          </div>



        </div>

      </div>
      <Footer />
    </>
  );
};

/** ----- Circular Coverflow Card ----- **/
// const CircleCard = ({ active, project, onClick, onHover }) => {
//   const cardRef = useRef(null);
//   const mouseX = useMotionValue(0);
//   const mouseY = useMotionValue(0);

//   const rotateX = useTransform(mouseY, [0, 1], [8, -8]);
//   const rotateY = useTransform(mouseX, [0, 1], [-8, 8]);
//   const scale = active ? 1.08 : 0.92;

//   const handleMouseMove = (e) => {
//     const rect = cardRef.current.getBoundingClientRect();
//     const x = (e.clientX - rect.left) / rect.width;
//     const y = (e.clientY - rect.top) / rect.height;
//     mouseX.set(x);
//     mouseY.set(y);
//     onHover?.(true);
//   };

//   const handleMouseLeave = () => {
//     mouseX.set(0.5);
//     mouseY.set(0.5);
//     onHover?.(false);
//   };

//   return (
//     <motion.div
//       ref={cardRef}
//       onMouseMove={handleMouseMove}
//       onMouseLeave={handleMouseLeave}
//       onClick={onClick}
//       style={{
//         ...styles.card,
//         transform: "translateZ(0)", // GPU hint
//         opacity: active ? 1 : 0.55,
//       }}
//       whileHover={{ y: -8 }}
//       animate={{ scale }}
//       transition={{ type: "spring", stiffness: 260, damping: 20 }}
//     >
//       {/* animated gradient ring */}
//       <div style={styles.ring}>
//         <div style={styles.ringInner} />
//       </div>

//       {/* circular image with sheen */}
//       <motion.div
//         style={{
//           ...styles.circle,
//           rotateX,
//           rotateY,
//           boxShadow: active
//             ? "0 24px 50px rgba(10, 23, 51, 0.25)"
//             : "0 16px 30px rgba(10, 23, 51, 0.15)",
//         }}
//       >
//         <img
//           src={project.image}
//           alt={project.title}
//           style={styles.circleImg}
//           draggable={false}
//         />

//         {/* glass overlay + title/desc */}
//         <motion.div
//           style={styles.glass}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: active ? 1 : 0.6 }}
//           transition={{ duration: 0.35 }}
//         >
//           <div style={styles.title}>{project.title}</div>
//           <div style={styles.desc}>{project.description}</div>
//           <motion.span
//             style={styles.cta}
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.98 }}
//           >
//             View details →
//           </motion.span>
//         </motion.div>

//         {/* specular sheen */}
//         <div style={styles.sheen} />
//       </motion.div>
//     </motion.div>
//   );
// };


const CircleCard = ({ project, onClick }) => {
  return (
    <motion.div
      onClick={onClick}
      style={{
        ...styles.card,
        opacity: 1, // always full bright card
      }}
      whileHover={{ y: -8, scale: 1.03 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
    >
      {/* circular image with dim overlay */}
      <div style={{ ...styles.circle, boxShadow: "0 16px 30px rgba(10, 23, 51, 0.15)" }}>
        <img
          src={project.image}
          alt={project.title}
          style={{ ...styles.circleImg, filter: "brightness(60%)" }} // dim image
          draggable={false}
        />

        {/* bright text overlay */}
        <motion.div
          style={{
            ...styles.glass,
            background: "rgba(255,255,255,0.9)", // brighter background
            border: "1px solid rgba(255,255,255,0.85)",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.35 }}
        >
          <div style={styles.title}>{project.title}</div>
          <div style={styles.desc}>{project.description}</div>
          <motion.span
            style={styles.cta}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
          >
            View details →
          </motion.span>
        </motion.div>
      </div>
    </motion.div>
  );
};

const styles = {
  container: {
    position: "relative",
    padding: "64px 5% 80px",
    minHeight: "100vh",
    // background: "#f9fafc",
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    // backgroundAttachment: AppConstant.backgroundAttachmentscroller,

    background:"white"

  },
  heading: {
    textAlign: "center",
    color: "#0A1733",
    fontSize: 56,
    fontWeight: 800,
    letterSpacing: -0.5,
    margin: 0,
  },
  subheading: {
    fontSize: '1rem',
    textAlign: 'center',
    marginBottom: '40px',
    fontWeight: "bold",
    fontStyle: 'italic',
    marginLeft: 'auto',
    marginRight: 'auto',
    // color: 'lightgrey',
    color: '#0A1733',
    // textTransform: "capitalize",

    // textDecoration: "underline 2px rgb(255, 101, 0)",

    textUnderlineOffset: "10px",
    letterSpacing: "2px",
  },

  carouselWrap: {
    position: "center",
    // marginTop: 20,

  },
  carousel: {
    display: "flex",
    gap: 36,
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    padding: "24px 2px 12px",
    scrollbarWidth: "none",
  },
  card: {
    flex: "0 0 360px",
    height: 420,
    scrollSnapAlign: "center",
    display: "grid",
    placeItems: "center",
    position: "relative",
    cursor: "pointer",
  },



  ring: {
    position: "absolute",
    width: 330,
    height: 330,
    // borderRadius: "50%",
    background:
      "conic-gradient(from 0deg, #f37021, #f5a45f, #ffd7b3, #8ab6ff, #4f7cff, #f37021)",
    filter: "blur(8px)",
    opacity: 0.35,
    animation: "spin 6s linear infinite",
  },
  ringInner: {
    position: "absolute",
    inset: 12,
    // borderRadius: "50%",
    background: "#f6f8fb",
  },
  circle: {
    width: 320,
    height: 320,
    borderRadius: "5%",
    overflow: "hidden",
    position: "relative",
    background: "#fff",
    transformStyle: "preserve-3d",
  },
  circleImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    // borderRadius: "50%",
  },
  glass: {
    position: "absolute",
    bottom: 12,
    left: "50%",
    transform: "translateX(-50%)",
    width: "82%",
    borderRadius: 16,
    padding: "12px 14px",
    background: "rgba(255,255,255,0.6)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.65)",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    textAlign: "center",
  },
  title: {
    fontWeight: 800,
    fontSize: 18,
    color: "#0A1733",
    marginBottom: 6,
  },
  desc: {
    fontSize: 13,
    color: "#2b3a55",
    opacity: 0.9,
    lineHeight: 1.35,
    marginBottom: 8,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textTransform: "capitalize",
  },
  cta: {
    display: "inline-block",
    fontSize: 13,
    fontWeight: 700,
    color: "#f37021",
  },
  arrowLeft: {
    position: "absolute",
    left: 24,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 5,
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: "#fff",
    border: "1px solid #eef0f6",
    boxShadow: "0 10px 24px rgba(10,23,51,0.12)",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
  },
  arrowRight: {
    position: "absolute",
    right: 24,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 5,
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: "#fff",
    border: "1px solid #eef0f6",
    boxShadow: "0 10px 24px rgba(10,23,51,0.12)",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
  },
  dots: {
    display: "flex",
    gap: 10,
    justifyContent: "center",
    marginTop: 18,
  },
  dot: {
    height: 8,
    borderRadius: 999,
    background: "#0A1733",
    border: "0",
    cursor: "pointer",
  },
};

/* keyframes (inject once in your app root, or keep here) */
const styleEl = document.createElement("style");
styleEl.innerHTML = `
@keyframes spin { to { transform: rotate(360deg); } }
::-webkit-scrollbar { display: none; }
`;
if (typeof document !== "undefined") {
  document.head.appendChild(styleEl);
}

export default Projects;
